
function tryGetEncodedParameter(instructions, parameterName) {
  const parameterStart = `${parameterName}*=`;
  const encodedInstruction = instructions.filter(cd => cd.startsWith(parameterStart))[0];
  if (encodedInstruction) {
    const parameterValue = encodedInstruction.substr(parameterStart.length);
    const matchedParts = /^UTF-8''(.*)$/i.exec(parameterValue);
    if (matchedParts && matchedParts.length === 2) {
      return decodeURIComponent(matchedParts[1]);
    }
  }

  return null;
}

function tryGetPlainParameter(instructions, parameterName) {
  const parameterStart = `${parameterName}=`;
  const instruction = instructions.filter(cd => cd.startsWith(parameterStart))[0];
  if (instruction) {
    const parameterValue = instruction.substr(parameterStart.length);
    const matchedParts = /^"?([^"]*)"?$/i.exec(parameterValue);
    if (matchedParts && matchedParts.length === 2) {
      return matchedParts[1];
    }
  }

  return null;
}

/**
 * Tenta ler um parâmetro de campo de cabeçalho.
 * Possui suporte a parâmetros encodificados (RFC 5987 @see https://tools.ietf.org/html/rfc5987)
 * @param {String} headerValue Valor do cabeçalho.
 * @param {String} parameterName Nome do parametro.
 * @returns {String} Valor do parametro, se existir, caso contrário, nulo.
 */
export function tryGetHeaderFieldParameterValue(headerValue, parameterName) {
  const instructions = headerValue
    .split(';')
    .map(cd => cd.trim());

  return tryGetEncodedParameter(instructions, parameterName)
    || tryGetPlainParameter(instructions, parameterName);
}

export function getFileNameFromHeader(response) {
  const contentDisposition = response.headers && (
    response.headers['Content-Disposition']
    || response.headers['content-disposition']
  );
  if (typeof contentDisposition === 'string') {
    return tryGetHeaderFieldParameterValue(contentDisposition, 'filename');
  }

  return null;
}
